import {procNewReport} from '../services/reportsDialog';
import {isDebugMode} from '../../../_shared/GWTBridge/invoke/procMain';

export function approveReportDlg(
    type: string,
    ename: string,
    mode: string,
    format: string,
    zoomValue: string,
    pdf: boolean
) {
    const debug = isDebugMode();
    procNewReport(type, ename, debug, mode, format, zoomValue, pdf);
}
